import React from "react";

const SearchIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.6503 12.2744L13.3443 12.6256L13.673 12.9557L18.3568 17.6588C18.5528 17.8556 18.5473 18.1639 18.3421 18.3545L18.3421 18.3546C18.2428 18.4469 18.1098 18.5 17.9642 18.5C17.8102 18.5 17.673 18.442 17.5713 18.3401L12.8522 13.6015L12.5599 13.308L12.2172 13.5406C10.9611 14.3928 9.49173 14.8425 7.94571 14.8425C3.82395 14.8425 0.5 11.6085 0.5 7.67124C0.5 3.73395 3.82395 0.5 7.94571 0.5C12.0675 0.5 15.3914 3.73395 15.3914 7.67124C15.3914 9.35853 14.7769 10.9815 13.6503 12.2744ZM14.3186 7.67124C14.3186 4.25215 11.4435 1.50119 7.94571 1.50119C4.44789 1.50119 1.57279 4.25215 1.57279 7.67124C1.57279 11.0903 4.44789 13.8413 7.94571 13.8413C11.4435 13.8413 14.3186 11.0903 14.3186 7.67124Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export default SearchIcon;
